import React, { ComponentProps } from 'react';

import { Chip } from '~/components/blocks';
import { ReceptionStatus } from '~/components/partials/ReceptionStatus';
import { DraftAppointmentStatus } from '~/graphql/generated/graphql';

type Props = {
  size?: ComponentProps<typeof Chip>['size'];
  status: DraftAppointmentStatus;
};

export const DraftAppointmentStatusLabel = (props: Props) => {
  const { status } = props;

  if (status === 'cancelled' || status === 'not_prescribed') {
    return <ReceptionStatus label="キャンセル" chipColor="honey" labelColor="black" />;
  }

  if (status === 'available') {
    return (
      <ReceptionStatus
        label="未受付"
        chipColor="green"
        labelColor="white"
        detailedStatus={{
          label: '処方箋到着待ち',
          color: 'black',
          iconName: 'drug',
        }}
      />
    );
  }

  if (status === 'wait_for_booking') {
    return (
      <ReceptionStatus
        label="未受付"
        chipColor="green"
        labelColor="white"
        detailedStatus={{
          label: '日時指定待ち',
          color: 'black',
          iconName: 'calender',
        }}
      />
    );
  }

  return <ReceptionStatus label="完了" chipColor="grey03" labelColor="black" />;
};
